var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_4218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2933 16.4693C10.0933 16.4693 9.96 16.4026 9.82667 16.2693L0.493335 6.93592C0.360002 6.80259 0.293335 6.53592 0.293335 6.33592C0.360002 6.13592 0.493335 5.93592 0.693335 5.86925L15.36 0.535919C15.6267 0.469253 15.8933 0.535919 16.0267 0.669253C16.2267 0.869253 16.2933 1.13592 16.16 1.33592L10.8267 16.0026C10.76 16.2026 10.56 16.4026 10.36 16.4026C10.36 16.4693 10.36 16.4693 10.2933 16.4693ZM2.16 6.73592L10.0267 14.6026L14.4933 2.26925L2.16 6.73592Z",
    fill: "#2D3138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29336 10.4695C4.09336 10.4695 3.89336 10.4028 3.76003 10.2028C3.56003 9.93613 3.56003 9.46947 3.89336 9.26947L15.2267 0.6028C15.4934 0.4028 15.96 0.4028 16.16 0.736134C16.36 1.0028 16.36 1.46947 16.0267 1.66947L4.69336 10.3361C4.56003 10.4028 4.42669 10.4695 4.29336 10.4695Z",
    fill: "#2D3138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29338 15.8024C3.89338 15.8024 3.62671 15.5357 3.62671 15.1357V9.80241C3.62671 9.40241 3.89338 9.13574 4.29338 9.13574C4.69338 9.13574 4.96004 9.40241 4.96004 9.80241V15.1357C4.96004 15.5357 4.69338 15.8024 4.29338 15.8024Z",
    fill: "#2D3138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29329 15.8023C4.15995 15.8023 4.02662 15.7357 3.89329 15.669C3.62662 15.469 3.55995 15.0023 3.82662 14.7357L6.15995 11.8023C6.35995 11.5357 6.82662 11.469 7.09329 11.7357C7.35995 11.9357 7.42662 12.4023 7.15995 12.669L4.75995 15.6023C4.69329 15.7357 4.49329 15.8023 4.29329 15.8023Z",
    fill: "#2D3138"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_4218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.293335 0.469238)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.100ef03dac0b75653ec325d87379a891.svg";
export { ForwardRef as ReactComponent };